import React from 'react';
import { Link } from 'react-router';
import Button from 'chameleon/ui-stack/ui/base/button';

const SpecificBuilderDetails = (props) => {
  const { quizzesDetails, warnings, errors, masterSubjectId, onAcknowledge } =
    props;

  return (
    <div className="p-8.4 flex flex-col gap-4">
      <div>
        <p className="font-medium text-14">
          The following quizzes were created:
        </p>
        {quizzesDetails.length === 0 ? (
          <p className="text-14">There aren&apos;t any quizzes created.</p>
        ) : (
          <ul className="m-0">
            {quizzesDetails.map((quiz) => (
              <li key={quiz.itemId}>
                <Link
                  className="text-14"
                  to={{
                    pathname: `/${masterSubjectId}/question_bank/create/preview/quiz`,
                    query: {
                      quizId: quiz.itemId,
                      editMode: false,
                      returnPath: `/${masterSubjectId}/question_bank/create`,
                    },
                  }}
                >
                  Preview quiz - {quiz.title} ({quiz.itemId})
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div>
        <p className="font-medium text-14">
          The following errors were encountered:
        </p>
        {errors.length === 0 ? (
          <p className="text-14">There aren&apos;t any errors.</p>
        ) : (
          <ul className="m-0">
            {errors.map((e) => (
              <li key={e} className="text-14">
                {e}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div>
        <p className="font-medium text-14">
          The following warnings were encountered:
        </p>
        {warnings.length === 0 ? (
          <p className="text-14">There aren&apos;t any warnings.</p>
        ) : (
          <ul className="m-0">
            {warnings.map((w) => (
              <li key={w} className="text-14">
                {w}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div>
        <Button onClick={onAcknowledge}>Create another quiz</Button>
      </div>
    </div>
  );
};

export default SpecificBuilderDetails;
